export const placeholderImage = 'https://www.survivorsuk.org/wp-content/uploads/2017/01/no-image.jpg'